const buildCode = 166;
const buildNumber = "0.6.48";

export { buildCode, buildNumber };
